module.exports = {"340705005":"东郊街道","340705006":"新城街道","340705100":"西湖镇","340705400":"铜陵市经济开发区","340705401":"狮子山国家高新区","340705402":"天井湖社区街道","340705403":"映湖社区街道","340705404":"五松社区街道","340705405":"人民社区街道","340705406":"幸福社区街道","340705407":"官塘社区街道","340705408":"学苑社区街道","340705409":"阳光社区街道","340705410":"友好社区街道","340705411":"螺蛳山社区街道","340705412":"露采社区街道","340705413":"金口岭社区街道","340705414":"鹞山社区街道","340705415":"朝阳社区街道","340705416":"滨江社区街道","340705417":"金山社区街道","340705418":"狮子山社区街道","340705419":"立新社区街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340705.json
// module id = 1192
// module chunks = 0